// For react must use prefix REACT_APP_ ex. REACT_APP_LINK or REACT_APP_CONFIG
export const appSubDomain = process.env.REACT_APP_DOMAIN || 'economical.ca';
export const FEbaseURL = process.env.REACT_APP_FE_ENDPOINT || 'http://sonnet.economical.ca:4000';
export const BFFbaseURL = process.env.REACT_APP_BFF_ENDPOINT || 'http://sonnet.economical.ca:3000';
export const appENV = process.env.REACT_APP_ENV || 'local';
export const GoogleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_KEY || 'AIzaSyD2Z0AE_7JhYF_TE88kzWbqyR0o8R_ehRI';
export const CHATBOT_URL = process.env.REACT_APP_CHATBOT_URL || 'http://claims.economical.ca';
export const GtmId = process.env.REACT_APP_GTM_ID || 'GTM-TF8DP3';
export const fullstoryKey = process.env.REACT_APP_FULLSTORY_KEY || '9F4DQ';
export const SONNET_AUTH_ORIGIN = process.env.REACT_APP_SONNET_AUTH_ORIGIN || 'https://dt7underwriting-pas.dev.economical-api.com';
export const avBucket = process.env.REACT_APP_AV_S3_BUCKET || 'dt7claims-lh-avdocumentsscan-bucket-origin';
export const mainBucket = process.env.REACT_APP_MAIN_S3_BUCKET || 'dt7claims-lh-ms-documents-bucket';
export const chatbotAppId = process.env.REACT_APP_CHATBOT_APP_ID || 'EconomicalTest1';
export const chatbotRegion = process.env.REACT_APP_CHATBOT_REGION || 'LAB';
export const appDKey = process.env.REACT_APP_APPD_KEY || 'AD-AAB-ACG-BAJ';
